import { FormCheckbox } from "@features/common/FormFields";
import "./styles.css";
import { Control } from "react-hook-form";
import { FormControl, FormLabel } from "@mui/material";
import { formControlStyle, formLabelStyle } from "../styles";
import { useTranslation } from "react-i18next";
import InfoBox from "../InfoBox";

interface Props {
  control: Control<any>;
  disabled: boolean;
  showPrompt: boolean;
  collapse?: boolean;
}

/**
 * Compatible with React Hook form, given that the validation
 * schema contains the following data structure:
 *
 * cloud_platforms: {
 *  aws: boolean
 *  azure: boolean
 *  gcp: boolean
 * }
 */
const CloudEnvironmentSelection = (props: Props) => {
  const { t } = useTranslation();
  return (
    <FormControl
      component="fieldset"
      sx={{ ...formControlStyle, width: props.collapse ? null : "100%" }}
    >
      <FormLabel component="legend" sx={formLabelStyle}>
        {t("label-cloud-platform")}
      </FormLabel>
      <div className="cloud_platform_selection">
        {props.showPrompt && (
          <div className="cloud_platform_selection__prompt">
            <InfoBox
              severity="info"
              variant="outlined"
              text={t("prompt-provide-cloud-platforms")}
              additionalText={t("description-provide-cloud-platforms")}
            />
          </div>
        )}
        <div className="cloud_platform_selection__checkboxes">
          <FormCheckbox
            name="cloud_platforms.aws"
            label="Amazon Web Services"
            control={props.control}
            disabled={true}
          />
          <FormCheckbox
            name="cloud_platforms.gcp"
            label="Google Cloud Platform"
            control={props.control}
            disabled={props.disabled}
          />
          <FormCheckbox
            name="cloud_platforms.azure"
            label="Microsoft Azure"
            control={props.control}
            disabled={props.disabled}
          />
        </div>
      </div>
    </FormControl>
  );
};

export default CloudEnvironmentSelection;
